module.exports = __webpack_public_path__ + "img/img2.2c7f3e42.jpg";